import MicroModal from "micromodal";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  EfectBlockUser,
  UserSupDesbloqInable,
  BlockUserInable,
} from "../../actions";

export default function BlockUnBlockUserModal({
  userout,
  horaaction,
  duration,
  reasonaction,
  setAct,
  act,
  actdesb,
  setActDesb,
  inable,
  idsup,
  idblock,
}) {
  const dispatch = useDispatch();

  const ActionUserSupDesbloq = (modal) => {
    let reason = document.getElementById(
      "anotc-add__textarea__input-desb"
    ).value;
    dispatch(EfectBlockUser(userout, act, reason));
    closeModal(modal);
  };

  const ActionUserSupDesbloqInable = (modal) => {
    let reason = document.getElementById(
      "anotc-add__textarea__input-desb"
    ).value;
    dispatch(UserSupDesbloqInable(reason, idblock, idsup));
    closeModal(modal);
  };

  const AlterBlockAction = (value) => {
    setAct(value);
    if (value === "1") {
      document.getElementById("logout-atd").checked = false;
    } else {
      document.getElementById("block-atd").checked = false;
    }
  };

  const AlterBlockActionDesb = (value) => {
    setActDesb(value);
    if (value === "1001") {
      document.getElementById("radio-22").checked = false;
    } else {
      document.getElementById("radio-11").checked = false;
    }
  };

  const ActionUserSup = (modal) => {
    let reason = document.getElementById("anotc-add__textarea__input").value;
    dispatch(EfectBlockUser(userout, act, reason));
    closeModal(modal);
  };

  const ActionBlockUserInable = (modal) => {
    let reason = document.getElementById("anotc-add__textarea__input").value;
    dispatch(BlockUserInable(userout, reason));
    closeModal(modal);
  };

  const closeModal = (modal) => {
    MicroModal.close(modal);
  };

  return (
    <>
      <div
        className="modal micromodal-slide"
        id="modal__bloqueio"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__bloqueio__title"
          >
            <header className="modal__header">
              <h2 className="modal__title" id="modal__bloqueio__title">
                Bloqueio
              </h2>

              <button
                className="modal__close"
                aria-label="Close modal"
                onClick={() => {
                  closeModal("modal__bloqueio");
                }}
                data-micromodal-close
              ></button>
            </header>
            <div className="modal__header__bottom-line"></div>
            <main
              className="modal__content modal__content--small"
              id="modal__bloqueio__content"
            >
              <div className="modal__content__user-details__content">
                <form action="" className="modal__content__form">
                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="modal__content--left">
                      <h3 className="modal-box__warning is-poppins">
                        Razão do bloqueio <br />
                      </h3>

                      <p className="modal-box__message">
                        Descreva a razão do bloqueio para o atendente
                      </p>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                    <div className="radio-content radio-content--column">
                      <div className="radio-button">
                        <input
                          type="radio"
                          id="block-atd"
                          name="block-atd"
                          onClick={() => AlterBlockAction("1")}
                          defaultChecked={act === "1" ? true : false}
                        />
                        <label htmlFor="block-atd">
                          <span>
                            <div className="mask"></div>
                          </span>

                          <div className="text">Bloquear</div>
                        </label>
                      </div>
                      {(() => {
                        if (inable === false) {
                          return (
                            <div className="radio-button">
                              <input
                                type="radio"
                                id="logout-atd"
                                name="logout-atd"
                                onClick={() => AlterBlockAction("2")}
                                defaultChecked={act === "2" ? true : false}
                              />
                              <label htmlFor="logout-atd">
                                <span>
                                  <div className="mask"></div>
                                </span>

                                <div className="text">Logout do atendente</div>
                              </label>
                            </div>
                          );
                        }
                      })()}
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="anotc-add__textarea">
                      <textarea
                        name="anotc-add__textarea__input"
                        id="anotc-add__textarea__input"
                        className="anotc-add__textarea__input"
                      ></textarea>
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                  <div className="modal__content__form__group modal__content__form__group--col-3">
                    <a
                      className="modal__content__form__group__button modal__content__form__group__button--white"
                      data-micromodal-close
                    >
                      Cancelar
                    </a>
                  </div>
                  <div className="modal__content__form__group modal__content__form__group--col-3">
                    {(() => {
                      if (inable === false) {
                        return (
                          <a
                            className="modal__content__form__group__button "
                            onClick={() => ActionUserSup("modal__bloqueio")}
                          >
                            OK
                          </a>
                        );
                      } else {
                        return (
                          <a
                            className="modal__content__form__group__button "
                            onClick={() =>
                              ActionBlockUserInable("modal__bloqueio")
                            }
                          >
                            OK
                          </a>
                        );
                      }
                    })()}
                  </div>
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>
      <div
        className="modal micromodal-slide"
        id="modal__desbloqueio"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__desbloqueio__title"
          >
            <header className="modal__header">
              <h2 className="modal__title" id="modal__desbloqueio__title">
                Desbloqueio
              </h2>

              <button
                className="modal__close"
                aria-label="Close modal"
                onClick={() => closeModal("modal__desbloqueio")}
                data-micromodal-close
              ></button>
            </header>
            <div className="modal__header__bottom-line"></div>
            <main
              className="modal__content modal__content--small"
              id="modal__desbloqueio__content"
            >
              <div className="modal__content__user-details__content">
                <form action="" className="modal__content__form">
                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="modal__content--left">
                      <h3 className="modal-box__warning is-poppins">
                        Razão do bloqueio <br />
                      </h3>

                      <p className="modal-box__message">
                        Descreva a razão do desbloqueio para o atendente
                      </p>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                    <div className="radio-content radio-content--column">
                      <div className="radio-button">
                        <input
                          type="radio"
                          id="radio-11"
                          name="radio-11"
                          onClick={() => AlterBlockActionDesb("1001")}
                          defaultChecked={actdesb === "1001" ? "checked" : ""}
                        />
                        <label htmlFor="radio-11">
                          <span>
                            <div className="mask"></div>
                          </span>

                          <div className="text">Desbloquear</div>
                        </label>
                      </div>
                      {(() => {
                        if (inable === false) {
                          return (
                            <div className="radio-button">
                              <input
                                type="radio"
                                id="radio-22"
                                name="radio-22"
                                onClick={() => AlterBlockActionDesb("3")}
                                defaultChecked={
                                  actdesb === "3" ? "checked" : ""
                                }
                              />
                              <label htmlFor="radio-22">
                                <span>
                                  <div className="mask"></div>
                                </span>

                                <div className="text">Logout do atendente</div>
                              </label>
                            </div>
                          );
                        }
                      })()}
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="modal__content__form__group__desc">
                      {/* <div className="modal__content__form__group__desc__item">
                                <strong>Bloqueado por:</strong>
                                Gabriel Ferreira
                                </div> */}
                      <div className="modal__content__form__group__desc__item">
                        <strong>Data de bloqueio:</strong>
                        {" " + duration}
                      </div>
                      <div className="modal__content__form__group__desc__item">
                        <strong>Hora de bloqueio:</strong>
                        {" " + horaaction}
                      </div>
                      <div className="modal__content__form__group__desc__item">
                        <strong>Razão do bloqueio:</strong>
                        <span>{" " + reasonaction}</span>
                      </div>
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="anotc-add__textarea">
                      <textarea
                        name="anotc-add__textarea__input"
                        id="anotc-add__textarea__input-desb"
                        className="anotc-add__textarea__input"
                      ></textarea>
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                  <div className="modal__content__form__group modal__content__form__group--col-3">
                    <a
                      className="modal__content__form__group__button modal__content__form__group__button--white"
                      data-micromodal-close
                    >
                      Cancelar
                    </a>
                  </div>
                  <div className="modal__content__form__group modal__content__form__group--col-3">
                    {(() => {
                      if (inable === false) {
                        return (
                          <a
                            className="modal__content__form__group__button "
                            onClick={() => ActionUserSupDesbloq()}
                          >
                            OK
                          </a>
                        );
                      } else {
                        return (
                          <a
                            className="modal__content__form__group__button "
                            onClick={() => ActionUserSupDesbloqInable()}
                          >
                            OK
                          </a>
                        );
                      }
                    })()}
                  </div>
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>
    </>
  );
}
